var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgNeuro4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 552,
    viewBox: "0 0 1440 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_538_3501)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_3501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 552
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 552H0V0H1440V552Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_3501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.139 -1069.98C665.76 -1094.54 695.903 -1104.22 720.464 -1091.6L1998.45 -434.856C2023.01 -422.234 2032.69 -392.092 2020.06 -367.531L1546.48 554.03C1533.86 578.587 1503.92 588.368 1479.37 575.753C1365.5 517.268 1056.31 358.439 840.648 247.511C625.49 136.841 315.161 -22.5718 201.005 -81.2067C176.438 -93.8257 166.946 -123.875 179.569 -148.44L653.139 -1069.98Z",
    fill: "#EAF4FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_538_3501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 552,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNeuro4);
export default __webpack_public_path__ + "static/media/bg-neuro4.e5140ea4f139bc87f29373b7e24b629a.svg";
export { ForwardRef as ReactComponent };